import { Box, Collapse, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { RADIUS } from 'DesignTokens';
import type { AdminFundUpdateEntry } from '../../models/FundUpdateEntry';
import { ReadOnlyBlocks } from '../FundUpdatesReadLayout';
import FundUpdateHeaderBar from './FundUpdateHeaderBar';
import type { useFundUpdatesAdmin } from './useFundUpdatesAdmin';

type FundUpdatesController = ReturnType<typeof useFundUpdatesAdmin>;

/**
 * A single entry in the "Existing Updates" list — its full content shown
 * read-only (same blocks as Fund Information, not editable in place), with
 * actions to open it into the canvas above, publish it, or delete it.
 */
export default function UpdateListRow({
  controller,
  update,
  onOpen,
  expanded = true,
  onToggleExpanded,
}: {
  controller: FundUpdatesController;
  update: AdminFundUpdateEntry;
  onOpen: (id: string | null) => void;
  expanded?: boolean;
  onToggleExpanded?: () => void;
}) {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: Palette.default.border,
        borderRadius: RADIUS.section,
        overflow: 'hidden',
        mb: 2,
      }}
    >
      <FundUpdateHeaderBar
        controller={controller}
        update={update}
        open={false}
        onOpen={onOpen}
        collapse={onToggleExpanded ? { expanded, onToggle: onToggleExpanded } : undefined}
      />
      <Collapse in={expanded} unmountOnExit>
        <Box sx={{ p: 2, bgcolor: 'background.paper' }}>
          {update.content.length > 0 ? (
            <ReadOnlyBlocks blocks={update.content} />
          ) : (
            <Typography variant="body2" color="text.secondary">
              No content yet.
            </Typography>
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
